import * as React from 'react';
import { useParams } from 'react-router';

// NOT USED CURRENTLY
export const ExpiredPaymentScreen = () => {
  const { id } = useParams<{ id: string }>();

  return <div>View/Edit expired payment id: {id} - NO NEED FOR VIEW SCREEN - DISABLE CLICK - DELETE SCREEN</div>;
};